import type { Attachment } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { FileContent } from './components'

interface Props {
  attachment: Attachment
  selected: boolean
}
export const AttachmentContent: React.FC<Props> = ({
  attachment: { type, data },
  selected,
}) => {
  switch (type) {
    case 'file':
      return <FileContent selected={selected} id={data.id} />
    default:
      return null
  }
}
